module.exports = __webpack_public_path__ + "media/images/85/REM_sleep_night_stars-e2e867f7671ac26bbd4a48d8d20aaecd.jpg";